import { useNavigate } from 'react-router-dom'

import { Upload } from '@factorialco/f0-react/icons/app'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { InsightTableType } from 'modules/finance/components/FinancialWorkspace/types/table'

interface Props {
  source: string
  variant?: string
  textButton?: string
  includeButtonIcon?: boolean
  insightTableType: InsightTableType
}

export const useUploadPayrollAction = ({
  source,
  textButton,
  insightTableType,
  includeButtonIcon,
  variant = 'default',
}: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const NAVIGATION_PATHS: Record<InsightTableType, string> = {
    [InsightTableType.EmployeeCosts]:
      navigation.finance.financialWorkspace.employee_costs.import_result.fullPath() +
      `?source=${InsightTableType.EmployeeCosts}`,
    [InsightTableType.Compensation]:
      navigation.finance.financialWorkspace.compensations.import_result.fullPath() +
      `?source=${InsightTableType.Compensation}`,
    [InsightTableType.Payroll]:
      navigation.finance.financialWorkspace.payroll.import_result.fullPath() +
      `?source=${InsightTableType.Payroll}`,
  }

  const {
    company: { id: currentCompanyId },
  } = useCurrentSession()

  const openModal = () => {
    track(trackingEvents.payroll.initImportPayrollSummaryFromExternal, {
      companyId: currentCompanyId,
      source,
    })
    goToImportResult()
  }

  const goToImportResult = () => {
    const path = NAVIGATION_PATHS[insightTableType]
    navigate(path)
  }

  return {
    variant,
    onClick: () => openModal(),
    icon: includeButtonIcon ? Upload : undefined,
    label: textButton || i18n.t('payroll_bundle.payroll_summary_import.button.default_button_text'),
  }
}
